export default {
    LOAD_STORE_GIFT_LISTS (state, storegiftlist) {
        state.items = storegiftlist
    }
}